import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertProfileContext } from "../../..";
import { validatePaymentForm } from "../../../utils/validators/PaymentFormValidator";
import { getAllDirtyFields } from "../../../utils/FieldValidators";
export const PAYPAL_PROCESS_NOT_REQUIRED = "paypalVerificationNotRequired";
export const PAYPAL_PROCESS_INITIATED = "paypalVerificationInitiated";
export const PAYPAL_WAITTING_FOR_CODE = "waitingForPaypalVerificationCode";
export const PAYPAL_PROCESS_COMPLETED = "paypalProcessCompleted";
const INITIAL_PAYPAL_STATE = {
  isOpen: false,
  state: PAYPAL_PROCESS_NOT_REQUIRED,
  title: ""
};
const PaymentForm = ({
  children
}) => {
  const {
    profile,
    loading,
    saveProfile,
    verifyPayPalAccount,
    updateProfile
  } = useExpertProfileContext();
  const [paypalAccount, setPaypalAccount] = React.useState({
    value: profile.paypalAccount || "",
    pristine: true,
    verificationStage: 0
  });
  const [paypalChangeStatus, setPaypalChangeStatus] = React.useState(INITIAL_PAYPAL_STATE);
  const [verifyPaypalError, setVerifyPaypalError] = React.useState(null);
  const [isEditPaypalAddress, setIsEditPaypalAddress] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);
  React.useEffect(() => {
    if (!(profile !== null && profile !== void 0 && profile.paypalAccount)) {
      setIsEditPaypalAddress(true);
    }
  }, [profile === null || profile === void 0 ? void 0 : profile.paypalAccount]);
  const updateProfileAndStatus = (paypalAccountValue, verificationStage, pristine = true, stage = 0) => {
    updateProfile({
      ...profile,
      paypalAccount: verificationStage === 0 && profile.paypalAccount ? profile.email : paypalAccountValue
    });
    setPaypalChangeStatus({
      isOpen: true,
      state: PAYPAL_PROCESS_COMPLETED,
      title: "Thank you!"
    });
    setIsEditPaypalAddress(false);
    setPaypalAccount({
      ...paypalAccount,
      pristine,
      verificationStage: stage
    });
  };
  const payPalVerify = (details = {}) => {
    verifyPayPalAccount({
      paypalAccount: paypalAccount.verificationStage === 0 && profile.paypalAccount ? profile.email : paypalAccount.value,
      ...details
    }, result => {
      if (result !== null && result !== void 0 && result.hasError) {
        var _result$error$graphQL, _result$error, _result$error$graphQL2;
        const {
          errorInfo
        } = (_result$error$graphQL = (_result$error = result.error) === null || _result$error === void 0 ? void 0 : (_result$error$graphQL2 = _result$error.graphQLErrors) === null || _result$error$graphQL2 === void 0 ? void 0 : _result$error$graphQL2[0]) !== null && _result$error$graphQL !== void 0 ? _result$error$graphQL : {};
        setVerifyPaypalError(errorInfo);
      } else {
        if (profile.email === paypalAccount.value && paypalAccount.verificationStage === 1 && profile.paypalAccount) {
          updateProfileAndStatus(paypalAccount.value, paypalAccount.verificationStage);
        } else if (details.verificationCode) {
          if (paypalAccount.verificationStage === 1 || !profile.paypalAccount) {
            updateProfileAndStatus(paypalAccount.value, paypalAccount.verificationStage);
          } else {
            setPaypalChangeStatus({
              isOpen: false,
              state: PAYPAL_PROCESS_NOT_REQUIRED,
              title: "Thank you!"
            });
            setIsEditPaypalAddress(paypalAccount.verificationStage !== 2 ? true : false);
            setPaypalAccount({
              ...paypalAccount,
              pristine: true,
              verificationStage: paypalAccount.verificationStage >= 2 ? 1 : paypalAccount.verificationStage + 1
            });
          }
        } else {
          setPaypalChangeStatus({
            isOpen: true,
            state: PAYPAL_WAITTING_FOR_CODE,
            title: paypalAccount.verificationStage === 0 && profile !== null && profile !== void 0 && profile.paypalAccount ? "Verify your current email address" : "Verify Paypal Account"
          });
        }
      }
    });
  };
  const clearVerifyPaypalError = () => {
    setVerifyPaypalError(null);
  };
  const onFormSubmit = callback => {
    if (paypalAccount.verificationStage === 0 && !profile.paypalAccount) {
      payPalVerify(paypalAccount);
    }
    if (paypalAccount.verificationStage === 1) {
      saveProfile(getAllDirtyFields({
        paypalAccount
      }), res => {
        // res undefined if paypal addressed used by other expert
        if (paypalAccount.verificationStage === 1) {
          var _res$verificationRequ, _res$verificationRequ2;
          if (res !== null && res !== void 0 && (_res$verificationRequ = res.verificationRequired) !== null && _res$verificationRequ !== void 0 && (_res$verificationRequ2 = _res$verificationRequ.fields) !== null && _res$verificationRequ2 !== void 0 && _res$verificationRequ2.includes("paypalAccount")) {
            setPaypalChangeStatus({
              isOpen: true,
              state: PAYPAL_PROCESS_INITIATED,
              title: "Verify PayPal account"
            });
          }
        }
        if (typeof callback === "function") {
          callback(res);
        }
      });
    }
  };
  const handlePaypalAccountChange = value => {
    setPaypalAccount({
      ...paypalAccount,
      value,
      pristine: false
    });
  };
  const {
    fieldErrors,
    isFormInvalid
  } = validatePaymentForm({
    paypalAccount,
    profile
  });
  return children({
    paypalAccount,
    fieldErrors,
    isFormInvalid,
    onFormSubmit,
    onPaypalAccountChange: handlePaypalAccountChange,
    onSubmitPayPalVerificationDetail: payPalVerify,
    verificationStatus: paypalChangeStatus,
    closePayPalVerification: () => setPaypalChangeStatus(INITIAL_PAYPAL_STATE),
    loading,
    verifyPaypalError,
    clearVerifyPaypalError,
    isEditPaypalAddress,
    setIsEditPaypalAddress,
    setPaypalAccount,
    profile,
    isSuccess,
    setIsSuccess
  });
};
export default PaymentForm;
PaymentForm.propTypes = {
  children: PropTypes.func.isRequired
};